import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Img from 'gatsby-image'
import TextGradient from '../gradient'

import styles from './styles'

const renderImage = props => {

  const { classes, section } = props

  return (
    section && section.image && section.image.src && section.image.src.length > 0 &&
      <img
        src={section.image.src}
        alt={section.image.alt}
        className={classes.sectionImage}
      />
  )
}


const Section = withStyles(styles)(props => {
  const { classes, section } = props

  return (
    <div className={classes.contents}>
      <div className={classes.section}>
        <Grid container spacing={40}>
          <Grid item xs={12}>
            {
              renderImage(props)
            }
            {section && section.contents && section.contents.map((content, index) => {
              return <SectionContent key={index} content={content} classes={classes} />
            })}
          </Grid>
        </Grid>
      </div>
    </div>
  )
})

const SectionContent = ({ content, classes }) => {
  return (
    <div>
      {
        content.title &&
        <Typography gutterBottom variant="title">
          {content.title.text}
        </Typography>
      }
      {
        content.subtitle &&
        <Typography gutterBottom variant="subheading">
          {content.subtitle.text}
        </Typography>
      }
      {
        content.text &&
        <div
          dangerouslySetInnerHTML={{ __html: content.text && content.text.html }}
          className={classes.text}
        />
      }
    </div>
  )
}

export default withStyles(styles)(Section)



// WEBPACK FOOTER //
// ./src/components/section/index.js